import React, { useEffect, useRef } from 'react';

import Map from '../Map/Map';
import { useConfigStore, useMapDataStore } from '../../stores';
import { prefetchFloorPlans } from '../FloorPlansPage/prefetchFloorPlans';
import { prefetchMedia } from '../MediaPage/prefetchMedia';
import { prefetchAmenities } from '../AmenitiesPage/prefetchAmenities';
import { markInteractiveMapVisited } from './prefetchInteractiveMap';

const InteractiveMapPage = () => {
  const config = useConfigStore((state) => state.config);
  const svgData = useMapDataStore((state) => state.svgData);
  const { communityNid, urlSlug } = config || {};
  const prefetchTriggeredRef = useRef( false );

  // Mark that user has visited Interactive Map (prevents unnecessary prefetching)
  useEffect(() => {
    markInteractiveMapVisited();
  }, []);

  // Prefetch Floor Plans, Media, and Amenities after map data loads (if not already visited)
  useEffect(() => {
    if (svgData && !prefetchTriggeredRef.current) {
      prefetchTriggeredRef.current = true;
      // Wait a bit longer for map as it's more complex
      const prefetchCallback = () => {
        setTimeout(() => {
          // Prefetch all three page types in parallel for instant navigation
          // Each function checks if already visited/in-progress before fetching
          prefetchFloorPlans(communityNid, urlSlug);
          prefetchMedia(urlSlug);
          prefetchAmenities(urlSlug);
        }, 2000);
      };
      // Use requestIdleCallback with setTimeout fallback for Safari
      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(prefetchCallback, { timeout: 3000 });
      } else {
        setTimeout(prefetchCallback, 100);
      }
    }
  }, [svgData, communityNid, urlSlug]);

  return (
    <div className="map">
      <Map />
    </div>
  );
};

export default InteractiveMapPage;
